import React from "react";
import { Input, InputProps } from "./input";
import { Label } from "./label";
import { siteSettings } from "../../settings/site-settings";

interface TranslatedInputProps extends InputProps {
  name: string;
  placeholder: string;
  values?: any; // has to come from Formik as object.
  errors?: any; // has to come from Formik as object.
  touched?: any; // has to come from Formik as object.
  columns?: number;
  gapX?: number;
  isEnglishMandatory?: boolean;

  [key: string]: any;
}

export const TranslatedInput = ({
  name,
  placeholder,
  values,
  errors,
  touched,
  columns = 1, // Default columns is 1
  gapX = 2, // Default gapX is 2
  isEnglishMandatory = true,
  ...props
}: TranslatedInputProps) => {
  return (
    <div className={`w-full grid grid-cols-${columns} gap-x-${gapX}`}>
      {siteSettings.translatedInputs.supportedLanguages.map((lang, index) => (
        <div key={lang} className={`my-2 flex flex-col items-start`}>
          {/* Custom Label component for each language */}
          <Label
            className="block text-body mb-2 text-sm px-1"
            htmlFor={`${name}.${lang}`}
          >
            {`${placeholder} (${lang.toUpperCase()}) ${
              lang === siteSettings.translatedInputs.defaultLanguage &&
              isEnglishMandatory
                ? "*"
                : ""
            }`}
          </Label>

          {/* Render Input for each language */}
          <Input
            id={`${name}.${lang}`}
            name={`${name}.${lang}`}
            placeholder={`Enter ${placeholder} in ${lang.toUpperCase()}`}
            error={touched?.[lang] && errors?.[lang] ? errors[lang] : ""}
            value={values?.[lang] || ""}
            className="input-ring bg-transparent text-white placeholder"
            {...props}
          />
        </div>
      ))}
    </div>
  );
};
